module.exports = __webpack_public_path__ + "img/computer.2f0491ca.png";